module.exports = __webpack_public_path__ + "img/triangle.d360dea1.svg";